"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwarenessChannel = exports.Region = void 0;
var Region;
(function (Region) {
    Region["SEOUL"] = "SEOUL";
    Region["GYEONGGI"] = "GYEONGGI";
    Region["GANGWON"] = "GANGWON";
    Region["CHUNGCHEONG_N"] = "CHUNGCHEONG_N";
    Region["CHUNGCHEONG_S"] = "CHUNGCHEONG_S";
    Region["GYEONGSANG_N"] = "GYEONGSANG_N";
    Region["GYEONGSANG_S"] = "GYEONGSANG_S";
    Region["JEOLLA_N"] = "JEOLLA_N";
    Region["JEOLLA_S"] = "JEOLLA_S";
    Region["JEJU"] = "JEJU";
    Region["BUSAN"] = "BUSAN";
    Region["DAEGU"] = "DAEGU";
    Region["ULSAN"] = "ULSAN";
    Region["GWANGJU"] = "GWANGJU";
    Region["INCHEON"] = "INCHEON";
    Region["SEJONG"] = "SEJONG";
    Region["ETC"] = "ETC";
})(Region || (exports.Region = Region = {}));
var AwarenessChannel;
(function (AwarenessChannel) {
    AwarenessChannel["PORTAL_SEARCH"] = "PORTAL_SEARCH";
    AwarenessChannel["SNS"] = "SNS";
    AwarenessChannel["OFFLINE_AD"] = "OFFLINE_AD";
    AwarenessChannel["SMS_EMAIL"] = "SMS_EMAIL";
    AwarenessChannel["ETC"] = "ETC";
    AwarenessChannel["COMMUNITY"] = "COMMUNITY";
    AwarenessChannel["MASS_MEDIA"] = "MASS_MEDIA";
    AwarenessChannel["REFERRAL"] = "REFERRAL";
    AwarenessChannel["APARTMENT_AD"] = "APARTMENT_AD";
})(AwarenessChannel || (exports.AwarenessChannel = AwarenessChannel = {}));
